import { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { Skeleton } from '@mint-lib/tw-components';

import { ScheduleTableType } from '../../../../types/queryScheduler.js';

const NameCell = ({ value, data }: ICellRendererParams<ScheduleTableType>) => {
  if (data?.__isSkeleton) {
    return <Skeleton />;
  }
  return <div>{value || 'New chat'}</div>;
};

export { NameCell };
